module.exports = __webpack_public_path__ + "static/img/interview-1-2.bcfac92.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/interview-1-2.png
// module id = JJK+
// module chunks = 1